const GET_VMS_AZURE = 'GET_VMS_AZURE';
const GET_VMS_AZURE_SUCCESS = 'GET_AZURE_VMS_SUCCESS';
const GET_VMS_AZURE_ERROR = 'GET_AZURE_VMS_ERROR';
 
export {
  GET_VMS_AZURE, GET_VMS_AZURE_SUCCESS, GET_VMS_AZURE_ERROR
  
};
